<template>
  <div class="comp-fh-table-header-more" @click.stop="" :style="{ position: 'absolute', zIndex: 1001, top: headerColInfoObj.top, left: headerColInfoObj.left, minWidth: '282px', maxWidth: '320px' }">
    <template v-if="!isSubForm">
      <h4 class="type-title">{{ $t('冻结') }}</h4>
      <div v-if="slotChecked" @click="changeSwitch(false)" class="sort-item field-sort-selected"><qfei-icon-unlock-outlined /> &nbsp;{{ $t('取消冻结') }}</div>
      <div v-else @click="changeSwitch(true)" class="sort-item"><qfei-icon-lock-outlined />&nbsp;{{ $t('冻结此列') }}</div>
      <template v-if="getIsNotSort()">
        <h4 class="type-title">{{ $t('排序') }}</h4>
        <template v-if="col?.fieldType == 9">
          <div class="sort-container">
            <div @click="sortChange(true, col, 'begin')" class="sort-item" :class="{ 'field-sort-selected': getFieldsSort(col, true, 'begin') }"><qfei-icon-ascending-order-outlined class="sort-icon" /> {{ $t('开始时间升序') }}</div>
            <div @click="sortChange(false, col, 'begin')" class="sort-item" :class="{ 'field-sort-selected': getFieldsSort(col, false, 'begin') }"><qfei-icon-ascending-order-outlined class="sort-icon" /> {{ $t('开始时间降序') }}</div>
            <div @click="sortChange(true, col, 'end')" class="sort-item" :class="{ 'field-sort-selected': getFieldsSort(col, true, 'end') }"><qfei-icon-descending-order-outlined class="sort-icon" /> {{ $t('结束时间升序') }}</div>
            <div @click="sortChange(false, col, 'end')" class="sort-item" :class="{ 'field-sort-selected': getFieldsSort(col, false, 'end') }"><qfei-icon-descending-order-outlined class="sort-icon" />{{ $t('结束时间降序') }}</div>
          </div>
        </template>
        <template v-else>
          <div class="sort-container">
            <div @click="sortChange(true, col)" class="sort-item" :class="{ 'field-sort-selected': fieldSort === true }"><qfei-icon-ascending-order-outlined class="sort-icon" />{{ $t('升序') }}</div>
            <div @click="sortChange(false, col)" class="sort-item" :class="{ 'field-sort-selected': fieldSort === false }"><qfei-icon-descending-order-outlined class="sort-icon" />{{ $t('降序') }}</div>
          </div>
        </template>
      </template>
    </template>
    <template v-if="col?.colKey !== 'businessId'">
      <h4 class="type-title">筛选</h4>
      <jw-space direction="vertical" fill class="space-fill-width">
        <template v-if="col?.fieldType === 9">
          <div class="date-range-box">
            <div class="date-range-item" v-for="item in dateRangeTypeList" :key="item.value" :class="{ 'date-range-item-active': dateRangeType === item.value }" @click="handleChangeDateRangeType(item.value)">{{ item.label }}</div>
          </div>
        </template>

        <div class="filter-condition-box">
          <jw-select v-if="col?.colKey === 'qccId' || col?.business?.fieldKey === 'qccId'" class="rule-form-item-sub-filter" v-model="conditionsItem.operation" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true }" @change="changeChildTwo($event)" allow-search allow-clear>
            <jw-option v-for="item in data.qccID" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
          </jw-select>
          <jw-select v-else class="rule-form-item-sub-filter" v-model="conditionsItem.operation" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true, contentClass: 'search-ultra-filter-select' }" @change="changeChildTwo($event, tools.isJSON(col?.fieldExt) && JSON.parse(col?.fieldExt)?.type)" allow-search allow-clear>
            <!-- 条件选择--根据字段类型是24的特殊处理（根据fieldExt中的type再区分条件） -->
            <template v-if="col?.fieldType === 24 || col?.business?.fieldType == 24">
              <jw-option v-for="item in getConditionFilterType(col?.colKey)" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
            </template>
            <template v-else>
              <jw-option v-for="item in filterOptions" :key="item.value" :value="item.value">{{ item.label }}</jw-option>
              <!-- 特殊处理属于当前值 -->
              <jw-option v-if="(col?.fieldType === 12 || col?.fieldType === 25) && col?.fieldExt == parentEntityId" :value="findAssociation.value">{{ findAssociation.label }}</jw-option>
            </template>
          </jw-select>
        </div>
        <table-item-fliter :key="randomKey" v-if="isShowFilter && conditionsItem.operation != 'null' && conditionsItem.operation != 'not_null' && conditionsItem.operation != 'equals_current_value'" :col="col" :conditionsItem="conditionsItem" @cb="updateModulesItem" :dateRangeType="dateRangeType"></table-item-fliter>
      </jw-space>
    </template>
  </div>
</template>

<script setup>
import { QfeiIconAscendingOrderOutlined, QfeiIconDescendingOrderOutlined, QfeiIconLockOutlined, QfeiIconUnlockOutlined } from '@qfei-design/icons-vue';
import { constFieldSort } from '@/utils/const';
import { useFilterListStore } from '@/store';
import { computed, inject, onUnmounted, reactive, ref, watch } from 'vue';
import { Message } from '@arco-design/web-vue';
import TableItemFliter from '@/components/customization/table-item-fliter/table-item-fliter.vue'; // 筛选条件
import { tools } from '@/utils/tools';
import md5 from 'js-md5';
import CONFIG from '@/config/config';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const useFilterList = useFilterListStore();
import _ from 'lodash';
const props = defineProps({
  headerColInfo: {
    type: Object,
    default: () => {}
  },
  isSubForm: {
    type: Boolean,
    default: false
  },
  ruleForm: {
    type: Object,
    default: () => ({})
  },
  column: {
    type: Object,
    default: () => {}
  },
  viewId: {
    type: String,
    default: ''
  }
});
const headerColInfoObj = computed(() => ({ ...props.headerColInfo }));
const col = computed(() => ({ ...props.column }));
const singleFiledForm = computed(() => JSON.parse(JSON.stringify(props.ruleForm)));
const fieldSort = ref(col.value?.fieldSort);
const emits = defineEmits(['colTitleFrozen', 'sortChange', 'getConditionParams']);
const data = reactive({
  sortChangeData: {
    col: ''
  },
  columns: inject('defaultParams')?.columns,
  isShow: false,
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //第一个
    objList: singleFiledForm.value.objList, //fieldKey：obj 类型
    filterType: singleFiledForm.value.filterType || {}, //中间
    isGroup: true,
    field: props.column.colKey,
    value: null,
    parentId: undefined,
    conditions: []
  },
  qccID: [
    {
      label: '为空',
      value: 'null',
      business: null,
      deleted: null
    },
    {
      label: '不为空',
      value: 'not_null',
      business: null,
      deleted: null
    }
  ]
});

const cols = ref([]);

const dateRangeType = ref('range');

const dateRangeTypeList = [
  {
    label: '日期区间',
    value: 'range'
  },
  {
    label: '开始时间',
    value: 'begin'
  },
  {
    label: '结束时间',
    value: 'end'
  }
];

// 日期区间类型切换
const handleChangeDateRangeType = (value) => {
  dateRangeType.value = value;
  conditionsItem.value.operation = null;
  conditionsItem.value.value = null;

  const currentContitions = data.ruleForm.conditions?.length ? JSON.parse(JSON.stringify(data.ruleForm.conditions)) : [];

  const num = currentContitions?.[0]?.children.length ? currentContitions?.[0]?.children.findIndex((child) => col.value.colKey === child.field) : -1;
  currentContitions[0]?.children.splice(num, 1);
  conditionsResult.value = currentContitions;
};

// 单个筛选项
const conditionsItem = ref({});
const oldConditionsItem = ref(''); //进入时候的筛选项
const slotChecked = ref('');
const conditionsResult = ref([]);
console.log(145, props.column, props.ruleForm.conditions);
const storage = {
  getItem(key) {
    let v = localStorage.getItem(key);
    if (v !== 'null' && v !== undefined) {
      v = JSON.parse(v);
    }
    return v;
  }
};
const isShowFilter = ref(false);

const filterOptions = computed(() => {
  const fieldType = col.value?.fieldType !== 21 ? col.value?.fieldType : col.value?.business?.fieldType || null;
  const baseOptions = ['begin', 'end'].includes(dateRangeType.value) ? singleFiledForm.value?.filterType[8] : singleFiledForm.value?.filterType[fieldType] || [];

  if (col.value?.fieldType === 10 || col.value?.business?.fieldType === 10) {
    return baseOptions.filter((item) => !['in', 'not_in'].includes(item.value));
  }
  return baseOptions;
});

// 点击更多图表标
const clickMoreIcon = async () => {
  // 要存储到本地数据的列数据
  // 生成唯一key
  isShowFilter.value = false;
  const uniqueKey = data.columns?.map((el) => el.colKey).join('') + data.columns?.length;
  // 保存默认列和实际列
  const tableKey = ref(`${CONFIG.prefix}QF_TABLE_COLS_${props.viewId}_${md5(uniqueKey)}`);
  const defCols = data.columns?.reduce((prev, cur) => {
    const tmp = {};
    if (cur.width) tmp.width = cur.width;
    if (cur.fixed) tmp.fixed = cur.fixed;
    if (cur.colShow === false) tmp.colShow = cur.colShow;
    prev[cur.colKey] = tmp;
    return prev;
  }, {});
  const defColsSort = data.columns?.map((el) => el.colKey);
  // 默认列的值
  const kf = storage.getItem(tableKey.value) || { k: defCols, sort: defColsSort };
  // 根据当前localStorage中的数据，生成新的columns
  const newColumns = data.columns.map((v) => {
    return {
      ...v,
      fixed: kf.k[v.colKey]?.fixed === 'left' ? 'left' : kf.k[v.colKey]?.fixed === 'right' ? 'right' : undefined,
      width: kf.k[v.colKey]?.width,
      colShow: kf.k[v.colKey]?.colShow
    };
  });
  // console.log(126, kf, tableKey.value, newColumns, props.column.colKey);
  newColumns?.forEach((v) => {
    if (v.colKey === props.column.colKey) {
      slotChecked.value = kf.k[props.column.colKey].fixed === 'left';
    }
  });
  // 将新的columns保存起来，传递给父组件，让父组件更新Table组件
  const indexMap = {};
  kf.sort?.forEach((key, index) => {
    indexMap[key] = index;
  });
  newColumns.sort((a, b) => {
    const indexA = indexMap[a.colKey];
    const indexB = indexMap[b.colKey];
    if (indexA === undefined && indexB === undefined) return 0;
    if (indexA === undefined) return 1;
    if (indexB === undefined) return -1;
    return indexA - indexB;
  });
  cols.value = newColumns;
  data.ruleForm = JSON.parse(JSON.stringify(props?.ruleForm || {}));
  console.log(190, data.ruleForm);
  conditionsResult.value = data.ruleForm?.conditions || [];
  // 保存打开时筛选项与退出时对比
  await getConditions(); // 处理数据的val
  isShowFilter.value = true;
  const oldCondition = updateCondition(conditionsResult.value);
  oldConditionsItem.value = oldCondition && oldCondition?.length ? JSON.stringify(oldCondition) : '';
};
// 初始化格式筛选value
const getConditions = async () => {
  // 处理数据设置setting
  await setConditionsFieldSetting(data.ruleForm.conditions);
  try {
    // eslint-disable-next-line no-debugger
    // debugger;
    const conditions = data.ruleForm.conditions;
    if (!conditions || conditions.length == 0) {
      data.ruleForm.conditions = [];
      data.ruleForm.fieldKey = t('全部数据');
    } else if (conditions.length) {
      conditions?.forEach((item) => {
        item.children?.forEach((sub) => {
          // 处理子表单的回显
          const remarkFieldKey = sub?.remark && sub.remark !== '' && tools.isJSON(sub.remark) ? JSON.parse(sub.remark)?.fieldKey : '';
          if (remarkFieldKey) {
            sub.field = sub.field + '.' + remarkFieldKey;
            const fieldObj = sub.setting.childSetting?.find((k) => k?.fieldKey === remarkFieldKey);
            console.log(217, fieldObj);
            if (fieldObj) {
              sub.setting = fieldObj;
            }
          }
          if (isUserDepartment(sub) && (sub.operation != 'null' || sub.operation != 'not_null')) {
            sub.value = _.isString(sub.value) && sub?.business && Object.keys(sub?.business)?.length > 0 ? sub.business : sub.value;
            if (_.isString(sub.value) || _.isArray(sub.value)) {
              return false;
            }
            const dept = sub.value?.departIds?.map((v) => v.name) || [];
            const user = sub.value?.userIds?.map((v) => v.name) || [];
            const userIds = sub.value?.userIds?.map((v) => v.id || []);
            const departIds = sub.value?.departIds?.map((v) => v.id || []);
            sub.userDept = [...dept, ...user];
            if (userIds) sub.userDeptIds = [...userIds];
            if (departIds) sub.userDeptIds = [...departIds];
            sub.userList = sub.value?.userIds?.map((v) => {
              return {
                ...v,
                userName: v.name,
                avatarOrigin: v.avatar
              };
            });
            sub.departList = sub.value?.departIds?.map((v) => {
              return {
                ...v,
                departmentName: v.name,
                avatarOrigin: v.avatar
              };
            });
            sub.value = JSON.stringify({
              userIds: userIds,
              departIds: departIds
            });
          }
          if (sub.operation === 'in' || sub.operation === 'not_in') {
            if (_.isString(sub.value)) {
              if (isCascader(sub) && sub.value?.includes('/')) {
                sub.value = sub.value?.split(',')?.map((str) => str.split('/'));
              } else {
                sub.value = sub?.value?.split(',');
              }
            }
          } else if (isCascader(sub) && (sub.operation == 'equals' || sub.operation == 'not_equals')) {
            console.log(667, sub.value);
            sub.value = sub.value && typeof sub.value === 'string' ? sub.value?.split('/') : sub?.value;
            console.log(668, sub.value);
          } else if (sub.operation === 'between') {
            if (isDateRange(sub) && !['begin', 'end'].includes(sub.subProperty)) {
              const parsedObject = tools.isJSON(sub.value) && JSON.parse(sub.value) ? JSON.parse(sub.value) : '';
              sub.value = [parsedObject.beginDate, parsedObject.endDate];
            }
          } else {
            // 兼容一下日期类型的数据，如果返回的是数组就变成字符串
            sub.value = Array.isArray(sub.value) ? sub.value.join() : sub.value;
          }
          // 处理数字
          if (isNumber(sub) && sub.operation !== 'null' && sub.operation !== 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) sub.value = Number(sub.value);
          }
          // 处理价格
          if (isPrice(sub) && sub.operation !== 'null' && sub.operation !== 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) sub.value = Number(sub.value) / 10000;
          }
          // 处理百分比字段类型
          if (isPercentage(sub) && sub.operation != 'null' && sub.operation != 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) {
              let fieldExt = '';
              if (sub.setting.fieldType === 21) {
                if (sub.setting?.business?.fieldType === 24) {
                  fieldExt = (tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt)?.numberFormat) || 2;
                }
              } else {
                if (sub.setting.fieldType === 24) {
                  fieldExt = (tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.numberFormat) || 2;
                }
              }
              sub.value = tools.getPercentage(sub.value, fieldExt);
            }
          }

          //特殊处理日期范围
          if (isDateRange(sub)) {
            if (['begin', 'end'].includes(sub.subProperty)) {
              dateRangeType.value = sub.subProperty;
            }
          }
          console.log(239001, sub, col.value.colKey);
          // (tools.isJSON(sub.remark) && sub.field + '.' + JSON.parse(sub.remark)?.colKey === col.value.colKey) ||
          if (sub.field === col.value.colKey) {
            conditionsItem.value = sub;
            console.log(239002, conditionsItem.value);
          }
        });
      });
      console.log(7361, conditions, conditionsItem.value);
      data.ruleForm.conditions = conditions;
    }
  } catch (e) {
    console.log(e, '失败了');
  }
};

// 追加字段属性
const setConditionsFieldSetting = async (array) => {
  array?.forEach((item) => {
    item?.children?.forEach((el) => {
      const fieldObj = data.ruleForm.leadsFieldList?.find((sub) => sub?.fieldKey == el.field || sub.arr?.includes(el.field));
      if (fieldObj) {
        el.setting = fieldObj;
        if (fieldObj?.childSetting?.length) {
          fieldObj.childSetting.forEach((m) => {
            if (el.field?.split('.')?.[1] == m.fieldKey) {
              el.setting = m;
            }
          });
        }
      }
    });
  });
};
// 级联
const isCascader = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 10 || child.setting?.business?.fieldType === 10;
};

// 日期区间
const isDateRange = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9;
};

// 数字
const isNumber = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 7 || child.setting?.business?.fieldType === 7 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 金额
const isPrice = (child) => {
  console.log(811, child);
  if (!child?.setting) return false;
  return child.setting.fieldType === 16 || child.setting?.business?.fieldType === 16 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 百分比
const isPercentage = (child) => {
  console.log(811, child);
  if (!child?.setting) return false;
  return child.setting.fieldType === 23 || child.setting?.business?.fieldType === 23 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [23]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [23]?.includes(JSON.parse(child.setting?.business?.fieldExt).type));
};
// 人员部门
const isUserDepartment = (child) => {
  if (!child?.setting) return false;
  return child.setting.fieldType === 6 || child.setting?.business?.fieldType === 6 || child.setting.fieldType === 22 || child.setting?.business?.fieldType === 22;
};

const getFieldsSort = (col, fieldSortType = null, subProperty = null) => {
  if (useFilterList.fieldsSort?.length) {
    const _obj = useFilterList.fieldsSort.find((item) => item.fieldKey == col.colKey);
    if (_obj && _obj.subProperty == subProperty && fieldSort.value === fieldSortType) {
      return true;
    }
  }
  return false;
};

const getIsNotSort = () => {
  return constFieldSort?.includes(props.column.fieldType) && props.col?.oldFieldType != 21;
};
// 升序降序切换
const sortChange = (v, col = null, subProperty = null) => {
  if (useFilterList.fieldsSort?.length >= 5) {
    Message.warning('排序最大支持5列');
    return;
  }
  const _obj = { fieldKey: props.column.colKey, fieldSort: v, isDefault: false, subProperty: '' };
  if (col.fieldType == 9) {
    if (subProperty) {
      _obj.subProperty = subProperty;
    }
  }
  data.sortChangeData.col = col;
  fieldSort.value = v;
  // 修改pinia
  useFilterList.setFieldsSort(_obj);
  emits('sortChange');
};
// 冻结按钮切换开关
const changeSwitch = (v) => {
  console.log(55, props.column.colKey, v, cols.value);
  slotChecked.value = v;
  // 将新的columns保存起来，传递给父组件，让父组件更新Table组件
  if (v) {
    Message.success('该列已冻结');
  } else {
    Message.success('该列已取消冻结');
  }
  emits('colTitleFrozen', props.column.colKey, v, cols.value);
};
// 获取条件下拉选择
const getConditionFilterType = (field) => {
  console.log(406, field, singleFiledForm.value);
  // data.filterType[data.objList[sub.field]?.fieldType != 21 ? data.objList[sub.field]?.fieldType : data.objList[sub.field]?.business?.fieldType]
  let list = [];
  const fieldType = singleFiledForm.value?.objList[field]?.fieldType;
  const drf = singleFiledForm.value?.filterType;
  const dro = singleFiledForm.value?.objList;
  if (fieldType == 21) {
    if (dro[field]?.business?.fieldType == 24) {
      const businessFieldExt = tools.isJSON(dro[field]?.business?.fieldExt) && JSON.parse(dro[field]?.business?.fieldExt);
      list = drf[dro[field]?.business?.fieldType][businessFieldExt?.type];
    } else {
      list = drf[dro[field]?.business?.fieldType];
    }
  } else {
    if (dro[field]?.fieldType == 24) {
      const fieldExt = tools.isJSON(dro[field]?.fieldExt) && JSON.parse(dro[field]?.fieldExt);
      list = drf[dro[field]?.fieldType][fieldExt?.type];
    } else {
      list = drf[dro[field]?.fieldType];
    }
  }
  // console.log(332, drf, dro, list);
  return list;
};
// const currentParams = ref({ operation: '', value: null });
const randomKey = ref(0);
// 第二个change事件
const changeChildTwo = (e, type) => {
  console.log(456, 'changeChildTwo', e, type);
  conditionsItem.value.value = null;
  conditionsItem.value.operation = e;
  const flp = conditionsItem.value;
  if (flp?.userDept || flp?.departList || flp?.userList || flp?.userIds || flp?.departIds || flp?.userDeptIds) {
    flp.userDept = [];
    flp.departList = [];
    flp.userList = [];
    flp.userIds = [];
    flp.departIds = [];
    flp.userDeptIds = [];
  }
  randomKey.value++;
  updateModulesItem({ operation: e });
};

// 组装筛选参数
const updateModulesItem = (e) => {
  console.log('筛选逻辑回调111', e);
  // debugger;
  // 只改变value时不触发
  if (!e.operation && e.value) {
    return;
  }
  const conditions = data.ruleForm.conditions?.length
    ? JSON.parse(JSON.stringify(data.ruleForm.conditions))
    : [
        {
          operation: 'and',
          isGroup: true,
          field: null,
          value: null,
          children: []
        }
      ];

  const num = conditions?.[0]?.children.length ? conditions?.[0]?.children.findIndex((child) => col.value.colKey === child.field) : -1;

  let chekConditionValue = true;
  if (tools.isJSON(e.value)) {
    const fvObj = JSON.parse(e.value);
    console.log(5371, fvObj);
    // 人员部门的特殊处理，人员部门value值为JSON字符串："{\"userIds\":[],\"departIds\":[]}"会判断为true
    if (col.value.fieldType === 6 || col.value.fieldType === 22) {
      if (!fvObj.userIds?.length && !fvObj.departIds?.length) {
        chekConditionValue = false;
      }
    }
  }

  if (num > -1) {
    // debugger;
    //日期范围特殊处理

    if (col.value?.fieldType === 9) {
      conditions[0].children[num].subProperty = ['begin', 'end'].includes(dateRangeType.value) ? dateRangeType.value : null;
    } else {
      if (['null', 'not_null'].includes(e.operation)) {
        // 更改筛选项
        conditions[0].children[num].value = null;
        conditions[0].children[num].operation = e.operation;
      } else if (e.operation && (e.value || e.value === 0) && chekConditionValue) {
        console.log(502149, e);
        conditions[0].children[num] = Object.assign(conditions[0]?.children[num], e);
      } else if (!e.value || !chekConditionValue) {
        // 删除筛选项
        console.log(21712, e);
        conditions[0]?.children.splice(num, 1);
      }
    }
  } else {
    if (!e.operation) {
      return;
    }

    conditions?.[0]?.children?.push(
      Object.assign(
        {
          field: col.value?.colKey,
          fieldType: col.value?.fieldType,
          subProperty: col.value?.fieldType == 9 && ['begin', 'end'].includes(dateRangeType.value) ? dateRangeType.value : null,
          isGroup: false
        },
        e
      )
    );
  }

  // 追加字段，调用父组件
  setConditionsFieldSetting(conditions);
  conditionsResult.value = conditions; // 处理数据
  console.log(502, conditionsResult.value);
};

const updateCondition = (conditions) => {
  const arr = JSON.parse(JSON.stringify(conditions || []))?.filter((item) => item.children?.length);

  arr?.forEach((item) => {
    item.children?.forEach((child) => {
      console.log(509, child, props.column);
      if (child?.field?.split('.')?.length == 2) {
        //说明是子表单
        const subFieldObj = props.column?.setting?.find((b) => b.fieldKey === child.field?.split('.')[1]);

        // if (subFieldObj) {
        console.log(5090, subFieldObj, child.field?.split('.')[1]);
        child.field = child.field?.split('.')[0];
        child.setting = subFieldObj;
        child['remark'] = tools.isJSON(child.remark) && JSON.parse(child.remark)?.fieldKey ? child.remark : subFieldObj ? JSON.stringify({ entity: subFieldObj.entityId, fieldKey: subFieldObj?.fieldKey, settingId: subFieldObj.id }) : null;
        // }
      }
      if (Array.isArray(child.value) && (child.operation === 'in' || child.operation === 'not_in')) {
        if (Array.isArray(child.value[0]) && isCascader(child)) {
          child.value = child.value?.map((subArr) => subArr.join('/')).join(',');
        } else {
          if (Array.isArray(child.value)) {
            child.value = child.value?.filter(Boolean).join(',');
          }
        }
      } else if (Array.isArray(child.value) && child.operation === 'between') {
        //只有日期，日期范围有'between'操作符
        const obj = {
          beginDate: child.value[0],
          endDate: child.value[1]
        };
        child.value = JSON.stringify(obj);
      } else if ((Array.isArray(child.value) && child.operation === 'equals') || child.operation === 'not_equals') {
        if (isCascader(child) && Array.isArray(child.value)) {
          child.value = child.value.join('/');
        }
      }
      if (isPrice(child) && child.operation != 'null' && child.operation != 'not_null') {
        child.value = child.value * 10000;
      }
      if (isNumber(child) && child.operation != 'null' && child.operation != 'not_null') {
        child.value = Number(child.value);
      }
      // 处理百分比字段类型
      if (isPercentage(child) && child.operation != 'null' && child.operation != 'not_null') {
        if (child.value && !isNaN(Number(child.value))) {
          let fieldExt = '';
          if (child.setting.fieldType === 21) {
            if (child.setting?.business.fieldType === 24) {
              fieldExt = (tools.isJSON(child.setting?.business?.fieldExt) && JSON.parse(child.setting?.business?.fieldExt)?.dataType) || 2;
            } else {
              fieldExt = (tools.isJSON(child.setting?.business?.fieldExt) && JSON.parse(child.setting?.business?.fieldExt)?.numberFormat) || 2;
            }
          } else {
            if (child.setting.fieldType === 24) {
              fieldExt = (tools.isJSON(child.setting?.fieldExt) && JSON.parse(child.setting?.fieldExt)?.dataType) || 2;
            } else {
              fieldExt = (tools.isJSON(child.setting?.fieldExt) && JSON.parse(child.setting?.fieldExt)?.numberFormat) || 2;
            }
          }
          console.log(fieldExt);
          child.value = tools.setPercentage(child.value, fieldExt);
        }
      }
      // 处理人员字段类型
      if (isUserDepartment(child)) {
        console.log(573, child);
        if (child.operation != 'null' || child.operation != 'not_null') {
          if (_.isObject(child.value)) {
            child.value = JSON.stringify({
              userIds: _.map(child.value.userIds, 'id'),
              departIds: _.map(child.value.departIds, 'id')
            });
          }
          child.fieldType = col.value.fieldType;
          child.business = null;
          child.userIds = undefined;
          child.departIds = undefined;
          child.departList = undefined;
        }
      }
      if (child.setting) delete child.setting;
    });
  });
  return arr;
};

const stopWatch = watch(
  () => props.column?.fieldSort,
  (v) => {
    fieldSort.value = v;
  },
  {
    deep: true,
    immediate: true
  }
);

const checkConditionValue = (conditionValue) => {
  if ([0, 1].includes(col.value.fieldType)) {
    return conditionValue ? true : false;
  }
  // 多选单选
  if ([2, 3, 4, 5].includes(col.value.fieldType)) {
    return conditionValue?.length ? true : false;
  }
  // 人员部门
  if (col.value.fieldType === 6 || col.value.fieldType === 22) {
    const copyValue = tools.isJSON(conditionValue) && JSON.parse(conditionValue);
    if (copyValue.userIds?.length || copyValue.departIds?.length) {
      return true;
    }
    return false;
  }
  return conditionValue || conditionValue == 0 ? true : false;
};

// 处理条件为空的场景
const handleCondition = (conditions) => {
  const copyConditions = JSON.parse(JSON.stringify(conditions));
  const resultList = copyConditions.filter((item) => {
    if (item.children?.length) {
      // Filter out children with no value or invalid operation
      item.children = item.children.filter((child) => ['null', 'not_null'].includes(child.operation) || (child.value != null && child.value !== ''));
      // Keep items that still have children after filtering
      return item.children.length > 0;
    }
    return false;
  });
  return resultList;
};

//抛出方法供父组件调用
const closedOverLay = () => {
  const currentConditions = handleCondition(conditionsResult.value);
  console.log('currentConditions', currentConditions);
  const newConditions = updateCondition(currentConditions);
  const previousConditions = oldConditionsItem.value;
  console.log('筛选逻辑回调222', newConditions, conditionsItem.value, conditionsResult.value);

  // debugger;

  // debugger;
  // 判断是否为无效操作类型
  const isInvalidOperation = () => {
    const { operation, value } = conditionsItem.value;

    const checkValue = checkConditionValue(value);

    return operation && !['null', 'not_null'].includes(operation) && !checkValue;
  };

  // "有值 → 无值"的变化
  const hasMeaningfulChange = () => {
    // 统一序列化新旧值（空数组转为空字符串）
    const newValueString = newConditions?.length ? JSON.stringify(newConditions) : '';
    const oldValueString = previousConditions || '';
    return newValueString !== oldValueString;
  };

  // 核心逻辑流
  if (isInvalidOperation()) {
    emits('getConditionParams', { type: false });
    return;
  }
  // 统一处理事件发射
  const emitConditionParams = (isValid) => {
    emits('getConditionParams', {
      conditions: newConditions,
      type: isValid
    });
  };
  emitConditionParams(hasMeaningfulChange());
};
onUnmounted(() => {
  console.log(1589, 'fh-table-more', '表格组件卸载了');
  stopWatch();
});
defineExpose({ clickMoreIcon, closedOverLay });
</script>
<style scoped lang="less">
@import './fh-table-header-more.less';
</style>
